import { useStoreActions } from "../../store/store-context";
import { PracticeManagement } from "../../types/api.model";
import PMSetupPage from "./PMSetupPage/PMSetupPage";
import { jsx as _jsx } from "react/jsx-runtime";
export const FinancialCentsSetupPage = () => {
  const {
    api,
    fetchFinancialCentsItems
  } = useStoreActions();
  return /*#__PURE__*/_jsx(PMSetupPage, {
    testid: "financial-cents-setup",
    pmName: PracticeManagement.FinancialCents,
    doDisconnect: api.financialCents.disconnect,
    getItems: fetchFinancialCentsItems,
    linkServiceTemplate: api.financialCents.linkServiceTemplate,
    getServiceTemplateIntegratedIds: template => template.integrations.financialCentsIntegratedIds()
  });
};